import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Table, ButtonGroup, IconButton, Icon, Panel, Row, Col, Grid, Avatar } from 'rsuite'
import pathname from '../../constants/pathname'
import AppContext from '../../context/AppContext'
import { getTest } from '../../redux/actions/dashboard'
import './styles.less'

const { Column, HeaderCell, Cell } = Table

export default function TableContractStatusWait() {
  const contextValue = React.useContext(AppContext)
  const history = useHistory()
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const mockSchema = {
    header: 'ข้อเสนอโครงการที่รอทำสัญญา/ข้อตกลง',
    projectCodeText: 'รหัสโครงการ',
    projectNameText: 'ชื่อโครงการ',
    projectTypeText: 'ประเภทโครงการ',
    projectStatusText: 'สถานะ',
    projectEditVerText: 'แก้ไขล่าสุด',
    totalSize: 40,
    values: [
      {
        projectVersionId: 'E1872F77-42CF-4A2A-8D16-1302E3907C02',
        id: 'R05-0010',
        type: { icon: 'file-o', label: 'โครงการ' },
        projectName: 'ปลูกผักในเมือง',
        colorstatus: { code: 3, label: 'คัดกรอง' },
        date: 'เวอร์ชั่น 1.0 15 พ.ค. 2564 07:48 น.',
      },
      {
        projectVersionId: '50CB2F7F-B273-414E-8282-2C779C1E689B',
        id: '64-04-0277',
        type: { icon: 'copy-o', label: 'ชุดโครงการ' },
        projectName: 'ลด ละ เลิก การดื่มแอลกอฮอล์ในชุมชน',
        colorstatus: { code: 4, label: 'กลั่นกรอง' },
        date: 'เวอร์ชั่น 1.0 15 พ.ค. 2564 05:45 น.',
      },
      {
        projectVersionId: 'EF0494FB-F222-4E94-987D-65DB454BD9F9',
        id: 'R05-0021',
        type: { icon: 'copy-o', label: 'ชุดโครงการ' },
        projectName: 'สนับสนุนทางวิชาการและการบริหารจัดการเครือข่ายสำหรับพื้นที่ชุมชน ',
        colorstatus: { code: 1, label: 'ร่างข้อเสนอโครงการ' },
        date: 'เวอร์ชั่น 1.0 14 พ.ค. 2564 01:38 น.',
      },
    ],
  }

  useEffect(() => {
    handelGetSchemaDashboard()
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    try {
      const response = await getTest()

      setSchema(mockSchema)
    } catch (e) {
      setError({})
    }
    setIsLoading(false)
  }

  const ImageCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0, marginTop: 8 }}>
      <Grid fluid>
        <Row>
          <Col
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              width: 40,
              height: 40,
              background: contextValue.theme[0] == 'dark' ? '#515151' : '#f5f5f5',
              borderRadius: 20,
              marginTop: 2,
              overflow: 'hidden',
              display: 'inline-block',
            }}
          >
            <Icon
              icon={rowData[dataKey].icon}
              size={'lg'}
              style={{ marginLeft: 6, marginTop: 10 }}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12} style={{ marginTop: 10 }}>
            {rowData[dataKey].label}
          </Col>
        </Row>
      </Grid>
    </Cell>
  )

  const TagCell = ({ rowData, dataKey, ...props }) => {
    let color
    switch (rowData[dataKey].code) {
      case 1:
        color = '#24c2a1'
        break
      case 2:
        color = '#24c2a1'
        break
      case 3:
        color = '#f88781'
        break
      case 4:
        color = '#f8bb6a'
        break
      case 5:
        color = '#70b4e5'
        break
      case 6:
        color = '#8cc2ff'
        break
    }
    return (
      <Cell {...props} style={{ padding: 13 }}>
        <div
          className="tag"
          style={{
            backgroundColor: color,
          }}
        >
          <span className="tag__text">{rowData[dataKey].label}</span>
        </div>
      </Cell>
    )
  }

  return (
    <>
      <Panel
        header={schema?.header}
        bordered
        collapsible
        shaded
        defaultExpanded
        className="table-all-project"
      >
        <Table wordWrap height={400} data={schema?.values || []}>
          <Column align="center" width={100} fixed>
            <HeaderCell>
              <span>รหัสโครงการ</span>
            </HeaderCell>
            <Cell dataKey="id" />
          </Column>
          <Column flexGrow={1}>
            <HeaderCell>
              <span>ชื่อโครงการ</span>
            </HeaderCell>
            <Cell dataKey="projectName" />
          </Column>
          <Column width={160}>
            <HeaderCell>
              <span>ประเภทโครงการ</span>
            </HeaderCell>
            <ImageCell dataKey="type" />
          </Column>
          <Column width={110}>
            <HeaderCell>
              <span>สถานะ</span>
            </HeaderCell>
            <TagCell dataKey="colorstatus" />
          </Column>
          <Column width={120}>
            <HeaderCell>
              <span>แก้ไขล่าสุด</span>
            </HeaderCell>
            <Cell dataKey="date" />
          </Column>
          <Column width={110} align="center" fixed="right">
            <HeaderCell>
              <span></span>
            </HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <ButtonGroup>
                    <IconButton
                      appearance="ghost"
                      icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                      onClick={() => {
                        sessionStorage.setItem('projectId', rowData.projectVersionId)
                        sessionStorage.setItem('param', '')

                        history.push({
                          pathname: `${pathname.proposal.overview.overviewCoworker}`,
                        })
                      }}
                    >
                      แสดง
                    </IconButton>
                  </ButtonGroup>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </Panel>
    </>
  )
}
